/**
 * Retiring a session — may the signed-in person? (build contract §2.8)
 *
 * Mirrors the authority check in `retire_session` (migration 758): the
 * session's facilitator, the person who created it, or a workspace admin.
 * Admins hold every permission action on the client, so `can('admin.settings')`
 * stands for the admin arm, the way cycleReportPublishRight uses
 * `process.publish`. The list draws Retire only for someone the act will
 * accept; the function stays the authority (it also refuses a session
 * something already depends on, and the dialog shows that refusal).
 */
import type { PermissionAction } from '../../types/prioritization/permissions';

export interface SessionRetireInput {
  userId: string | null | undefined;
  facilitatorId: string | null | undefined;
  createdBy: string | null | undefined;
  can: (action: PermissionAction) => boolean;
}

export function sessionRetireAllowed({ userId, facilitatorId, createdBy, can }: SessionRetireInput): boolean {
  if (!userId) return false;
  if (facilitatorId && facilitatorId === userId) return true;
  if (createdBy && createdBy === userId) return true;
  return can('admin.settings');
}
